import PropTypes from 'prop-types';
import React from 'react';

import CheckBox from './CheckBox';
import LabeledControl from './LabeledControl';

function LabeledCheckBox({
  bold = false,
  label,
  value,
  onChange = () => {},
  alignRight = false,
  underline = false,
  disabled = false,
  labelSize = '30%',
  reverse = false,
  checkboxMarginLeft = undefined,
  name
}:{
  value: boolean,
  onChange: (x:boolean) => void,
  disabled?: boolean,
  reverse?: boolean,
  label: string,
  labelSize?: string,
  alignRight?: boolean,
  bold?: boolean,
  underline?: boolean,
  checkboxMarginLeft?: string|undefined,
  name?: string,
}) {
  return <LabeledControl
    bold={bold}
    label={label}
    labelSize={labelSize}
    underline={underline}
    alignRight={alignRight}
    reverse={reverse}
    controlMarginLeft={checkboxMarginLeft}
    control={<CheckBox name={`${name}-check`} value={value} onChange={onChange} disabled={disabled} />}
  />;
}

LabeledCheckBox.defaultProps = {
  onChange: () => {},
  value: '',
  bold: false,
  alignRight: false,
  underline: false,
  disabled: false,
  labelSize: '30%',
  reverse: false,
};

LabeledCheckBox.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.bool.isRequired,
  bold: PropTypes.bool.isRequired,
  alignRight: PropTypes.bool.isRequired,
  underline: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  labelSize: PropTypes.string.isRequired,
  reverse: PropTypes.bool.isRequired,
  checkboxMarginLeft: PropTypes.string
};


export default React.memo(LabeledCheckBox);
